'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';

export function LeaderboardHero({ imageSrc }: { imageSrc: string }) {
  const t = useTranslations('leaderboard');

  return (
    <section className="relative h-[280px] md:h-[360px]">
      <Image src={imageSrc} alt="Leaderboard" fill className="object-cover" priority />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white">{t('title')}</h1>
        </div>
      </div>
    </section>
  );
}
